<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div id="panel-protocol" class="panel">
                    <div class="panel-hdr bg-primary-700 bg-success-gradient">
                        <h2>
                           {{this.protocol?.protocol_title}}
                        </h2>
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                        </div>
                    </div>
                    
                    <div class="panel-container collapse show overflow-auto">
                        <div class="panel-content">
                            
                            <div class="panel-tag mb-3 ">
                                <reduction_head :protocol="protocol"></reduction_head>
                            </div>
                            
                            <div class="p-2">
                                <reduction_positions
                                    :can_edit="show"
                                    :protocol="protocol"></reduction_positions>
                            </div>
                            
                            <div class="p-2">
                                <reduction_winners :protocol="protocol"></reduction_winners>
                                <protocol_description :protocol="protocol"></protocol_description>
                            </div>
                        </div>
                    </div>
                    
                    <div class="container-fluid pb-4" v-if="show">
                        <div class="row">
                            <div class="col-12">
                                
                                <div class="btn btn-primary  waves-effect waves-themed mr-2" v-on:click="close">
                                    Закрити
                                </div>
                                
                                <div class="btn btn-outline-success  waves-effect waves-themed mr-2" v-on:click="saveProtocol">
                                    Зберегти
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <position_change_model :protocol="protocol"></position_change_model>
    </div>
</template>

<script>
import Reduction_head from "./fields/reduction_head.vue";
import Reduction_positions from "./fields/reduction_positions.vue";
import Reduction_winners from "./fields/reduction_winner.vue";
import Protocol_description from "../../protocol/create/tabs/protocol_description.vue";
import Position_change_model from "./positions/position_change_model.vue";

export default {
    name: "reduction_inside",
    components: {Position_change_model, Protocol_description, Reduction_winners, Reduction_positions, Reduction_head},
    
    props: {
        protocol_id: {
            type: [Number, String],
            default : 0,
        },
        
        tender_id : {
            type: [Number, String],
            default : 0,
        },
        
        show : {
            type : Boolean,
            default : true,
        }
    },
    data() {
        return {
            is_load: false,
            is_loaded : false,
            tabId : "protocol_general",
            protocol : {
                id : 0,
                rate_from_protocol : 0,
                position_grid_add : [],
                calculated_sum : {
                    cur_sum : 0,
                    opt_sum : 0,
                }
            },
            tabs : []
        }
    },
    
    created() {
        EventBus.$on('application:updated',this.loadProtocol);
        this.protocol.id = this.protocol_id;
        this.loadProtocol();
    },
    
    methods : {
        
        close() {
            window.location.href ="/protokoly";
        },
        
        async saveProtocol() {
            let  url = '/tenders/sales/tenders/' + parseInt(this.tender_id) + "/protocol" + "/" + this.protocol_id;
            
            this.is_load = true;
            await api.put(url,{
                'protocol' : this.protocol,
                'type' : "second_reduction",
                
            }).then(({data}) => {
                let protocol_id = parseInt(data.data);
                if(protocol_id > 0) {
                    window.location.href = '/protokoly/edit/' + protocol_id;
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                })
            });
        },
        
        async loadProtocol(currency_type = -1) {
            this.is_load = true;
            this.is_loaded = false;
            let self = this;
            let body = {
                'tender_id'     : this.tender_id,
                'protocol_id'   : this.protocol.id,
            }
            
            if(parseInt(currency_type) >= 0) {
                body['rate_from_protocol'] = currency_type;
            }
            
            await axios.post('/internal/protocol/getProtocol',body).then(({data}) => {
                this.is_load = false;
                this.is_loaded = true;
                if(data.status === "operation_success") {
                    self.protocol = data.data;
                }
            }).catch(({response}) => {
                console.log(response);
                EventBus.$emit('show_toast', {
                    err: response.data.message, type: "danger",
                    title: response.data.status,
                    position : "b-toaster-top-left"
                })
            });
        },
    }
    
}
</script>



<style scoped>

</style>